import style from '../head-to-head.module.scss';

const getArrows = (index, leftData, rightData) => {
  let rightArrow = 'hidden';
  let leftArrow = 'hidden';
  if (rightData && rightData[index] && rightData[index].absolute_leader) {
    rightArrow = style.arrowMiddle;
    if (index === 0) {
      if (rightData[index + 1] && rightData[index + 1].absolute_leader) {
        rightArrow = style.arrowStart;
      } else {
        rightArrow = style.arrowSmall;
      }
    } else if (
      index > 0 &&
      rightData[index - 1] &&
      !rightData[index - 1].absolute_leader
    ) {
      if (rightData[index + 1] && rightData[index + 1].absolute_leader) {
        rightArrow = style.arrowStart;
      } else {
        rightArrow = style.arrowSmall;
      }
    } else if (
      index <= rightData.length &&
      rightData[index + 1] &&
      !rightData[index + 1].absolute_leader
    ) {
      rightArrow = style.arrowEnd;
    }
    if (index + 1 === rightData.length) {
      rightArrow = style.arrowEnd;
    }
  }
  if (leftData && leftData[index] && leftData[index].absolute_leader) {
    leftArrow = style.arrowMiddle;
    if (index === 0) {
      if (leftData[index + 1] && leftData[index + 1].absolute_leader) {
        leftArrow = style.arrowStart;
      } else {
        leftArrow = style.arrowSmall;
      }
    } else if (index > 0 && leftData[index - 1] && !leftData[index - 1].absolute_leader) {
      if (leftData[index + 1] && leftData[index + 1].absolute_leader) {
        leftArrow = style.arrowStart;
      } else {
        leftArrow = style.arrowSmall;
      }
    } else if (
      index <= leftData.length &&
      leftData[index + 1] &&
      !leftData[index + 1].absolute_leader
    ) {
      leftArrow = style.arrowEnd;
    }
    if (index + 1 === leftData.length) {
      if (leftData[index - 1] && leftData[index - 1].absolute_leader) {
        leftArrow = style.arrowEnd;
      } else {
        leftArrow = style.arrowSmall;
      }
    }
  }
  return [leftArrow, rightArrow];
};

export { getArrows };
